import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="kontakt">
      <div className="footer-grid">
        <div className="footer-brand">
          <h3>MediConsult Group</h3>
          <p>
            Das Dr. Hoffmann-Prinzip — Schnell. Smart. Skalierbar.
            <br />
            Wir starten in Hamburg und erweitern PLZ-basiert deutschlandweit.
          </p>
        </div>
        <div className="footer-col">
          <h4>Angebot</h4>
          <ul>
            <li><Link to="/buchen">Termin buchen</Link></li>
            <li><a href="/#lizenz">Lizenzpartner werden</a></li>
            <li><a href="/#tarife">Tarife</a></li>
            <li><a href="/#aktion">Mai-Aktion</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Konto</h4>
          <ul>
            <li><Link to="/einloggen">Login</Link></li>
            <li><Link to="/registrieren">Registrieren</Link></li>
            <li><Link to="/konto">Mein Konto</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Kontakt</h4>
          <ul>
            <li>MediConsult Group</li>
            <li>Cremon 11</li>
            <li>20457 Hamburg</li>
            <li>
              <a href="https://mediconsult.group" target="_blank" rel="noopener noreferrer">
                mediconsult.group
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} MediConsult Group · Alle Rechte vorbehalten</span>
        <div>
          <Link to="/impressum">Impressum</Link>
          <Link to="/datenschutz">Datenschutz</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
